import React, {Component} from 'react';
import PropTypes from 'prop-types';
import LaddaButton, {ZOOM_OUT} from 'react-ladda';

class Button extends Component {
  render() {
    let classes = ['btn btn-ladda'];
    classes.push('btn-' + this.props.color);
    if(this.props.className){
      classes.push(this.props.className);
    }

    classes.push('btn-' + this.props.size);

    return <LaddaButton
      id={this.props.id}
      className={classes.join(' ')}
      disabled={this.props.disabled}
      loading={this.props.loading}
      data-style={ZOOM_OUT}
      onClick={this.props.onClick}
    >{this.props.children}</LaddaButton>;
  }
}

Button.defaultProps = {
  disabled: false,
  loading: false,
  color: 'primary',
  onClick: null,
  className: [],
  size: 'md',
};

Button.propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.array,
  size: PropTypes.oneOf(['sm', 'md', 'lg']).isRequired,
};

export default Button;
